// import * as ArrayTools from '../array-tools';

import {
  Dict,
  SfFormData,
  SfFormField,
  SfFormFieldErrorCode,
} from "@/types/generalTypes";

export function getFieldErrors(
  field: SfFormField,
  formFields?: Dict<SfFormField>,
) {
  const errors: SfFormFieldErrorCode[] = [];
  let fieldValue = field.value;

  if (typeof fieldValue == "string") {
    fieldValue = fieldValue.trim();
  }

  if (field.required) {
    if (
      !fieldValue ||
      fieldValue.length < 1 ||
      (field.isDate && fieldValue.trim() == "NaN-NaN-NaN")
    ) {
      errors.push("required");
    }
  }

  if (field.isEmail && fieldValue.length > 0) {
    if (!_isValidEmail(fieldValue)) {
      errors.push("invalidEmail");
    }
  }

  if (field.match && formFields) {
    let matchValue = formFields[field.match].value;
    if (typeof matchValue == "string") {
      matchValue = matchValue.trim();
    }
    if (fieldValue != matchValue) {
      errors.push("match");
    }
  }

  if (field.minLength) {
    if (fieldValue.length < field.minLength) {
      errors.push("minLength");
    }
  }

  if (field.minValue !== undefined) {
    if (fieldValue < field.minValue) {
      errors.push("minValue");
    }
  }

  return errors;
}

export function validateForm(formData: SfFormData) {
  const newFields: Dict<SfFormField> = {};
  let isValid = true;
  for (const k in formData.fields) {
    const errors = getFieldErrors(formData.fields[k], formData.fields);
    newFields[k] = { ...formData.fields[k], errors, touched: true };
    if (errors.length > 0) {
      isValid = false;
    }
  }
  return { ...formData, isValid, fields: newFields };
}

function _isValidEmail(email: string) {
  // return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  const len = email.length;
  if (len < 5) {
    return false;
  }
  const atPos = email.indexOf("@");
  if (atPos < 1) {
    return false;
  }
  if (email.lastIndexOf("@") != atPos) {
    return false;
  }
  const dotPos = email.lastIndexOf(".");
  if (dotPos < atPos + 2) {
    return false;
  }
  if (len - dotPos < 3) {
    return false;
  }
  return true;
}
